/**
 * @voltxampere/engine — Capacitor DC stamp
 *
 * In DC steady state a capacitor is an open circuit — `i = C dV/dt`
 * goes to zero when `dV/dt = 0`, so the element makes no admittance
 * contribution. We model this as a no-op stamp. Sprint 6's transient
 * solver will replace this with a companion model whose `Geq`/`Ieq`
 * terms depend on the integration method (BE/TRAP/Gear-2) and the
 * previous time-step's voltage.
 *
 * The `initialVoltage` and `voltageRating` parameters are recognised
 * for forward compatibility but ignored at DC. Sprint 6 will use
 * `initialVoltage` to seed the transient state.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { defineDCStamp } from "../definition.js";
export const capacitorDCStamp = (_ctx, _component) => {
    // Intentionally empty: open circuit at DC. See file-level docstring.
};
/** DC capacitor is open-circuit — no rows, no RHS. Transient adds a Norton. */
export const capacitorDCStampDefinition = defineDCStamp("capacitor", capacitorDCStamp, []);
//# sourceMappingURL=capacitor.js.map